// src/components/DashboardAdmin.tsx

import axios from "axios";
import React, { useEffect, useState } from "react";

import borrar from '../assets/img/ICON_ALIADAS/DELETE/DELETE_#37285f.png';
import borrarDM from '../assets/img/ICON_ALIADAS/DELETE/DELETE_WHITE.png';

import download from '../assets/img/ICON_ALIADAS/DOWNLOAD/DOWNLOAD_#37285f.png';
import downloadDM from '../assets/img/ICON_ALIADAS/DOWNLOAD/DOWNLOAD_WHITE.png';

import edit from '../assets/img/ICON_ALIADAS/EDIT/EDIT_#37285f.png';
import editDM from '../assets/img/ICON_ALIADAS/EDIT/EDIT_WHITE.png';

import questionIcon from "../assets/img/ICON_ALIADAS/FAQ/FAQ_#37285f.png";
import questionIconDM from "../assets/img/ICON_ALIADAS/FAQ/FAQ_WHITE.png";

import moonIcon from "../assets/img/ICON_ALIADAS/MOON/MOON_WHITE.png";

import logoutIcon from "../assets/img/ICON_ALIADAS/SETTINGS/SETTINGS_#37285f.png";
import logoutIconDM from "../assets/img/ICON_ALIADAS/SETTINGS/SETTINGS_WHITE.png";

import sunIcon from "../assets/img/ICON_ALIADAS/SUN/SUN_#37285f.png";

import switchleft from "../assets/img/ICON_ALIADAS/SWITCH/SWITCH_LEFT.png";
import switchright from "../assets/img/ICON_ALIADAS/SWITCH/SWITCH_RIGHT.png";

import logo_dia from "../assets/img/logo_fondotransparente_horizontal_Mesa de trabajo 1_Mesa de trabajo 1_Mesa de trabajo 1.png";
import logo_noche from "../assets/img/logo_fondotransparente_horizontal_Mesa de trabajo 1_Mesa de trabajo 1_Mesa de trabajo 2.png";

import shareIcon from "../assets/img/ICON_ALIADAS/SHARE/SHARE_37285F.png";
import shareIconDM from "../assets/img/ICON_ALIADAS/SHARE/SHARE_WHITE.png";

import { default as lupaIcon, default as lupaIconDM } from "../assets/img/lupa.png";

import dashboard from "../styles/dashboard.module.css";
import "../styles/global.css";

import { URL_SERVER } from "../utils/Utils";

import { useTheme } from "../context/AppThemeContext";

import folderIcon from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER-#37285f.png";
import folderIconDM from "../assets/img/ICON_ALIADAS/FOLDER/FOLDER_WHITE.png";

import secureLocalStorage from "react-secure-storage";

import {
  FileItem,
  FolderItem,
  Item
} from "../utils/Types";

import { useDashboardData } from "../hooks/useDashboardDataAdmin";

import Sidebar from "./Sidebar";


const Dashboard: React.FC = () => {

  /*
   * ============================================================
   * TEMA
   * ============================================================
   */

  const { isNight, toggleNightMode } = useTheme();

  const logoActual =
    isNight ? logo_noche : logo_dia;

  const switchIcon =
    isNight ? switchright : switchleft;

  const modeIcon =
    isNight ? moonIcon : sunIcon;

  const lupaActual =
    isNight ? lupaIconDM : lupaIcon;

  const questionActual =
    isNight ? questionIconDM : questionIcon;

  const logoutActual =
    isNight ? logoutIconDM : logoutIcon;

  const borrarActual =
    isNight ? borrarDM : borrar;

  const editActual =
    isNight ? editDM : edit;

  const downloadActual =
    isNight ? downloadDM : download;

  const folderActual =
    isNight ? folderIconDM : folderIcon;

  const shareActual =
    isNight ? shareIconDM : shareIcon;


  /*
   * ============================================================
   * TOKEN
   * ============================================================
   */

  const storageToken =
    secureLocalStorage.getItem("token");

  const token =
    typeof storageToken === "string"
      ? storageToken
      : null;


  /*
   * ============================================================
   * DATOS DEL DASHBOARD
   * ============================================================
   */

  const {

    nameSearch,
    setNameSearch,

    files,
    folders,

    showModal,
    setShowModal,

    newFolderName,
    setNewFolderName,

    showPolicyModal,
    setShowPolicyModal,

    sidebarOpen,
    setSidebarOpen,

    showOptions,
    setShowOptions,

    viewMode,
    setViewMode,

    openMenuKey,
    setOpenMenuKey,

    showUploadFileModal,
    setShowUploadFileModal,

    selectedFile,
    setSelectedFile,

    showEditModal,
    setShowEditModal,

    editName,
    setEditName,

    editItemId,
    setEditItemId,

    editIsFolder,
    setEditIsFolder,

    modalOpen,
    setModalOpen,

    openModal,
    closeModal,

    showShareModal,
    setshowShareModal,

    isAdmin,

    fetchData,
    fetchDataFiltered,

    goToTrash,

    handleFolderClick,

    goToAdmin,

    toggleItemMenu,

    handleDownload,

    handleDelete,

    handleEdit,

    allItems,

    getFileIcon,

    searchUser,

    searchUserForShare,

    shareEmail,
    setshareEmail,

    updateShare,

    handleShare,

    navigate,

    shareMessage,

    closeShareModal

  } = useDashboardData();


  /*
   * ============================================================
   * CARPETAS ABIERTAS
   * ============================================================
   */

  const [
    expandedFolders,
    setExpandedFolders
  ] = useState<Set<string>>(
    new Set()
  );


  const toggleFolder = (
    folderId: string
  ) => {

    setExpandedFolders(
      previous => {

        const next =
          new Set(previous);

        if (
          next.has(folderId)
        ) {
          next.delete(folderId);
        } else {
          next.add(folderId);
        }

        return next;

      }
    );

  };


  const isFolderExpanded = (
    folderId: string
  ): boolean => {

    return expandedFolders.has(
      folderId
    );

  };


  /*
   * ============================================================
   * CARGA INICIAL
   * ============================================================
   */

  useEffect(() => {

    setNameSearch("");

    fetchData();

  }, []);


  /*
   * ============================================================
   * ARCHIVOS
   * ============================================================
   */

  const renderFileRow = (
    file: FileItem,
    level: number
  ): React.ReactNode => {

    return (

      <tr
        key={
          `file-${file.id}-${level}`
        }
      >

        <td>

          <div
            style={{
              paddingLeft:
                `${level * 28}px`,

              display: "flex",

              alignItems:
                "center"
            }}
          >

            <span
              style={{
                width: "24px",
                display:
                  "inline-block"
              }}
            />

            <span>
              📄
            </span>

            <span
              style={{
                marginLeft: "8px"
              }}
            >
              {file.name}
            </span>

          </div>

        </td>


        <td>

          {new Date(
            file.creation_date
          ).toLocaleDateString()}

        </td>


        <td>

          {new Date(
            file.last_update_date
          ).toLocaleDateString()}

        </td>


        <td>

          <img
            src={borrarActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleDelete(
                file.id,
                false
              )
            }
            alt="Borrar"
          />

        </td>


        <td>

          <img
            src={editActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleEdit(
                file.id,
                false,
                file.name
              )
            }
            alt="Editar"
          />

        </td>


        <td>

          <img
            src={shareActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleShare(
                file.id,
                false
              )
            }
            alt="Compartir"
          />

        </td>


        <td>

          {/* ABRIR EN COLLABORA */}

          <img
            src={folderActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() => {

              const collaboraUrl =
                process.env
                  .REACT_APP_COLLABORA_URL;

              const wopiUrl =
                process.env
                  .REACT_APP_WOPI_URL;

              const editorUrl =
                `${collaboraUrl}/browser/dist/cool.html` +
                `?WOPISrc=${wopiUrl}/api/wopi/files/${file.id}` +
                `&access_token=123` +
                `&access_token_ttl=0`;

              window.open(
                editorUrl,
                "_blank"
              );

            }}
            alt="Abrir"
            title="Abrir con Collabora"
          />

        </td>


        <td>

          {/* DESCARGAR */}

          <img
            src={downloadActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleDownload(
                file.id,
                file.name
              )
            }
            alt="Descargar"
          />

        </td>

      </tr>

    );

  };


  /*
   * ============================================================
   * CARPETAS
   * ============================================================
   *
   * Esta función es recursiva.
   *
   * carpeta
   *   ├── carpeta hija
   *   │     └── archivo
   *   │
   *   └── archivo
   *
   */

  const renderFolderRows = (
    folder: FolderItem,
    level: number = 0
  ): React.ReactNode[] => {

    const expanded =
      isFolderExpanded(
        folder.id
      );

    const rows:
      React.ReactNode[] = [];


    /*
     * La flecha aparece si la carpeta
     * tiene subcarpetas o archivos.
     */

    const hasChildren =
      folder.children.length > 0 ||
      folder.files.length > 0;


    /*
     * ------------------------------------------------------------
     * FILA DE LA CARPETA
     * ------------------------------------------------------------
     */

    rows.push(

      <tr
        key={
          `folder-${folder.id}`
        }
      >

        <td>

          <div
            style={{
              paddingLeft:
                `${level * 28}px`,

              display: "flex",

              alignItems:
                "center"
            }}
          >

            {hasChildren ? (

              <button
                type="button"
                onClick={() =>
                  toggleFolder(
                    folder.id
                  )
                }
                style={{
                  border: "none",
                  background:
                    "transparent",
                  cursor: "pointer",
                  fontSize: "16px",
                  width: "24px",
                  padding: 0
                }}
                aria-label={
                  expanded
                    ? "Cerrar carpeta"
                    : "Abrir carpeta"
                }
              >

                {expanded
                  ? "▼"
                  : "▶"}

              </button>

            ) : (

              <span
                style={{
                  width: "24px",
                  display:
                    "inline-block"
                }}
              />

            )}


            <img
              src={folderActual}
              className={
                dashboard.iconosfila
              }
              alt="Carpeta"
            />


            <button
              className={
                `${dashboard.folderLink} folderLink`
              }
              onClick={() =>
                handleFolderClick(
                  folder.id
                )
              }
            >

              {folder.name}

            </button>

          </div>

        </td>


        <td>

          {new Date(
            folder.creation_date
          ).toLocaleDateString()}

        </td>


        <td>

          {new Date(
            folder.last_update_date
          ).toLocaleDateString()}

        </td>


        <td>

          <img
            src={borrarActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleDelete(
                folder.id,
                true
              )
            }
            alt="Borrar"
          />

        </td>


        <td>

          <img
            src={editActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleEdit(
                folder.id,
                true,
                folder.name
              )
            }
            alt="Editar"
          />

        </td>


        <td>

          <img
            src={shareActual}
            className={
              dashboard.iconosTabla
            }
            onClick={() =>
              handleShare(
                folder.id,
                true
              )
            }
            alt="Compartir"
          />

        </td>


        <td />

      </tr>

    );


    /*
     * Si está cerrada, terminamos aquí.
     */

    if (!expanded) {

      return rows;

    }


    /*
     * ------------------------------------------------------------
     * CARPETAS HIJAS
     * ------------------------------------------------------------
     */

    folder.children.forEach(
      childFolder => {

        rows.push(

          ...renderFolderRows(
            childFolder,
            level + 1
          )

        );

      }
    );


    /*
     * ------------------------------------------------------------
     * ARCHIVOS DE ESTA CARPETA
     * ------------------------------------------------------------
     */

    folder.files.forEach(
      file => {

        rows.push(

          renderFileRow(
            file,
            level + 1
          )

        );

      }
    );


    return rows;

  };


  return (

    <div
      className={
        dashboard.container
      }
    >

      {/* =====================================================
          NUEVA CARPETA
      ====================================================== */}

      {showModal && (

        <div
          className={
            dashboard.modal_overlay
          }
        >

          <div
            className={
              dashboard.modal
            }
          >

            <h3>
              Nueva carpeta
            </h3>

            <input
              type="text"
              placeholder="Nombre de la carpeta"
              value={
                newFolderName
              }
              onChange={
                e =>
                  setNewFolderName(
                    e.target.value
                  )
              }
              className={
                dashboard.modal_input
              }
            />

            <div
              className={
                dashboard.modal_buttons
              }
            >

              <button
                onClick={() =>
                  setShowModal(false)
                }
              >
                Cancelar
              </button>


              <button
                onClick={async () => {

                  if (!token) {
                    return;
                  }

                  try {

                    const parts =
                      token.split(".");

                    if (
                      parts.length !== 3
                    ) {
                      throw new Error(
                        "Token mal formado"
                      );
                    }

                    const payloadBase64 =
                      parts[1];

                    const decodedPayload =
                      JSON.parse(
                        atob(
                          payloadBase64
                        )
                      );

                    const userId =
                      decodedPayload?.id ??
                      decodedPayload?.user_id ??
                      decodedPayload?.sub;

                    if (!userId) {
                      return;
                    }

                    await axios.post(

                      `${URL_SERVER}/v2/folders`,

                      {
                        name:
                          newFolderName,

                        creation_user_id:
                          userId
                      },

                      {
                        headers: {
                          Authorization:
                            `Bearer ${token}`,

                          "Content-Type":
                            "application/json"
                        }
                      }

                    );

                    await fetchData();

                    setNewFolderName("");

                    setShowModal(false);

                  } catch (error) {

                    console.error(
                      "Error al crear carpeta:",
                      error
                    );

                  }

                }}
              >
                Crear
              </button>

            </div>

          </div>

        </div>

      )}


      {/* =====================================================
          FAQ
      ====================================================== */}

      {showPolicyModal && (

        <div
          className={
            dashboard.modal_overlay
          }
        >

          <div
            className={
              dashboard.modal
            }
          >

            <h3
              className={
                dashboard.tituloFAQ
              }
            >
              ¿Para qué sirve este espacio?
            </h3>


            <div
              className={
                dashboard.modal_content
              }
            >

              <p>
                En este espacio podrás guardar,
                organizar y compartir toda la
                documentación e información
                vinculada a los proyectos del
                Programa Aliadas de la Dirección
                General de Juventud del Gobierno
                de Canarias.
              </p>

            </div>


            <div
              className={
                dashboard.modal_buttonss
              }
            >

              <button
                onClick={() =>
                  setShowPolicyModal(
                    false
                  )
                }
              >
                Cerrar
              </button>

            </div>

          </div>

        </div>

      )}


      {/* =====================================================
          SUBIR ARCHIVO
      ====================================================== */}

      {showUploadFileModal && (

        <div
          className={
            dashboard.modal_overlay
          }
        >

          <div
            className={
              dashboard.modal
            }
          >

            <h3>
              Subir Archivo
            </h3>


            <input
              type="file"
              onChange={e => {

                const file =
                  e.target.files?.[0];

                if (file) {
                  setSelectedFile(
                    file
                  );
                }

              }}
              className={
                dashboard.modal_input
              }
            />


            <div
              className={
                dashboard.modal_buttons
              }
            >

              <button
                onClick={() =>
                  setShowUploadFileModal(
                    false
                  )
                }
              >
                Cancelar
              </button>


              <button
                onClick={async () => {

                  if (!selectedFile) {
                    return;
                  }

                  if (!token) {
                    return;
                  }

                  try {

                    const parts =
                      token.split(".");

                    if (
                      parts.length !== 3
                    ) {
                      throw new Error(
                        "Token mal formado"
                      );
                    }

                    const decodedPayload =
                      JSON.parse(
                        atob(parts[1])
                      );

                    const userId =
                      decodedPayload?.id ??
                      decodedPayload?.user_id ??
                      decodedPayload?.sub;

                    if (!userId) {
                      return;
                    }

                    const formData =
                      new FormData();

                    formData.append(
                      "file",
                      selectedFile
                    );

                    formData.append(
                      "creation_user_id",
                      userId
                    );


                    await axios.post(
                      `${URL_SERVER}/v2/files`,
                      formData,
                      {
                        headers: {
                          Authorization:
                            `Bearer ${token}`,

                          "Content-Type":
                            "multipart/form-data"
                        }
                      }
                    );


                    await fetchData();

                    setSelectedFile(
                      null
                    );

                    setShowUploadFileModal(
                      false
                    );

                  } catch (error) {

                    console.error(
                      "Error al subir archivo:",
                      error
                    );

                  }

                }}
              >
                Subir
              </button>

            </div>

          </div>

        </div>

      )}


      {/* =====================================================
          EDITAR
      ====================================================== */}

      {showEditModal && (

        <div
          className={
            dashboard.modal_overlay
          }
        >

          <div
            className={
              dashboard.modal
            }
          >

            <h3>
              Editar nombre
            </h3>


            <input
              type="text"
              placeholder="Nuevo nombre"
              value={
                editName
              }
              onChange={e =>
                setEditName(
                  e.target.value
                )
              }
              className={
                dashboard.modal_input
              }
            />


            <div
              className={
                dashboard.modal_buttons
              }
            >

              <button
                onClick={() =>
                  setShowEditModal(
                    false
                  )
                }
              >
                Cancelar
              </button>


              <button
                onClick={async () => {

                  if (!editItemId) {
                    return;
                  }

                  if (!token) {
                    return;
                  }

                  try {

                    await axios.put(

                      `${URL_SERVER}/v2/${editIsFolder ? "folders" : "files"}/names/${editItemId}`,

                      {
                        name:
                          editName
                      },

                      {
                        headers: {
                          "Content-Type":
                            "application/json",

                          Authorization:
                            `Bearer ${token}`
                        }
                      }

                    );


                    await fetchData();

                    setShowEditModal(
                      false
                    );

                    setEditName("");

                    setEditItemId("");

                  } catch (err) {

                    console.error(
                      "Error al editar nombre:",
                      err
                    );

                  }

                }}
              >
                Guardar
              </button>

            </div>

          </div>

        </div>

      )}


      {/* =====================================================
          COMPARTIR
      ====================================================== */}

      {showShareModal && (

        <div
          className={
            dashboard.modal_overlay
          }
        >

          <div
            className={
              dashboard.modal
            }
          >

            <h3>
              Compartir
            </h3>


            <input
              type="email"
              placeholder="Busqueda por correo..."
              value={
                shareEmail
              }
              onChange={e =>
                setshareEmail(
                  e.target.value
                )
              }
              className={
                dashboard.modal_input
              }
            />


            <div
              className={
                dashboard.share_button_container
              }
            >

              <button
                className={
                  dashboard.share_button
                }
                onClick={() =>
                  closeShareModal()
                }
              >
                Cancelar
              </button>


              <button
                className={
                  dashboard.share_button
                }
                onClick={() =>
                  searchUserForShare(
                    shareEmail
                  )
                }
              >
                Buscar
              </button>

            </div>


            {searchUser != null && (

              <div>

                <p>
                  ¿Desea compartir con{" "}
                  {searchUser.name}{" "}
                  {searchUser.surename}{" "}
                  ({searchUser.username})?
                </p>


                <button
                  className={
                    dashboard.share_button
                  }
                  onClick={() =>
                    updateShare(
                      editItemId,
                      editIsFolder,
                      searchUser
                    )
                  }
                >
                  Compartir
                </button>


                {shareMessage && (

                  <p>
                    {shareMessage}
                  </p>

                )}

              </div>

            )}

          </div>

        </div>

      )}


      {/* =====================================================
          SIDEBAR
      ====================================================== */}

      <aside
        className={
          `${dashboard.sidebar} ${
            sidebarOpen
              ? dashboard.sidebarActive
              : ""
          }`
        }
      >

        <div
          className={
            dashboard.newButtonContainer
          }
        >

          <button
            className={
              dashboard.newButton
            }
            onClick={() =>
              setShowOptions(
                !showOptions
              )
            }
          >
            + Nuevo
          </button>


          {showOptions && (

            <div
              className={
                dashboard.optionsMenu
              }
            >

              <div
                onClick={() => {

                  setShowModal(
                    true
                  );

                  setShowOptions(
                    false
                  );

                }}
              >
                Nueva Carpeta
              </div>


              <div
                onClick={() => {

                  setShowUploadFileModal(
                    true
                  );

                  setShowOptions(
                    false
                  );

                }}
              >
                Subir Archivo
              </div>

            </div>

          )}


          {isAdmin && (

            <div
              className={
                dashboard.newButtonContainer
              }
            >

              <button
                className={
                  dashboard.newButton
                }
                onClick={() =>
                  goToAdmin()
                }
              >
                + Panel de administración
              </button>

            </div>

          )}


          <Sidebar
            token={token}
            isAdmin={isAdmin}
            goToAdmin={goToAdmin}
          />

        </div>

      </aside>


      {/* =====================================================
          CONTENIDO
      ====================================================== */}

      <main
        className={
          dashboard.content
        }
      >

        <header>

          <span
            className={
              `${dashboard.menuToggle} menuToggle`
            }
            onClick={() =>
              setSidebarOpen(
                !sidebarOpen
              )
            }
          >
            &#9776;
          </span>


          <h2
            className={
              dashboard.Bienvenidos
            }
          >

            <p className="BienvenidosTitulo">
              Bienvenidas a
            </p>

            <img
              className={
                dashboard.logo
              }
              src={logoActual}
              alt="logo"
            />

          </h2>


          <div
            className={
              `${dashboard.search_bar} search_bar`
            }
          >

            <input
              type="text"
              placeholder="Buscar"
              className="search_input"
              onChange={e =>
                setNameSearch(
                  e.target.value
                )
              }
            />


            <button
              onClick={() =>
                fetchDataFiltered(
                  nameSearch
                )
              }
            >

              <img
                src={lupaActual}
                className={
                  `${dashboard.search_icon} search_icon`
                }
                alt="Buscar"
              />

            </button>

          </div>


          <div
            className={
              dashboard.icons
            }
          >

            <a
              onClick={() =>
                setShowPolicyModal(
                  true
                )
              }
            >

              <img
                src={questionActual}
                className={
                  dashboard.iconos
                }
                alt="FAQ"
              />

            </a>


            <a
              onClick={
                toggleNightMode
              }
            >

              <img
                src={switchIcon}
                className={
                  dashboard.iconos
                }
                alt="switch"
              />

            </a>


            <img
              src={modeIcon}
              className={
                dashboard.iconos
              }
              alt="Modo Día/Noche"
            />


            <a
              onClick={() =>
                navigate("/user")
              }
            >

              <img
                src={logoutActual}
                className={
                  dashboard.iconos
                }
                alt="Cerrar sesión"
              />

            </a>

          </div>

        </header>


        {/* =====================================================
            CAMBIO DE VISTA
        ====================================================== */}

        <button
          className={
            dashboard.viewToggle
          }
          onClick={() =>
            setViewMode(
              viewMode === "list"
                ? "grid"
                : "list"
            )
          }
        >

          {viewMode === "list"
            ? "Mosaico"
            : "Lista"}

        </button>


        {/* =====================================================
            VISTA LISTA
        ====================================================== */}

        {viewMode === "list" ? (

          <div
            className={
              dashboard.tableResponsive
            }
          >

            <table
              border={1}
              className={
                dashboard.tablaprinc
              }
            >

              <thead>

                <tr>

                  <th>
                    Nombre
                  </th>

                  <th>
                    Fecha de Creación
                  </th>

                  <th>
                    Última Actualización
                  </th>

                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>

                </tr>

              </thead>


              <tbody>

                {folders.length > 0 ? (

                  <>

                    {folders.map(
                      folder =>
                        renderFolderRows(
                          folder,
                          0
                        )
                    )}

                  </>

                ) : (

                  <tr
                    className={
                      dashboard.noItemsRow
                    }
                  >

                    <td colSpan={7}>
                      No hay elementos disponibles
                    </td>

                  </tr>

                )}

              </tbody>

            </table>

          </div>

        ) : (

          /* ===================================================
             VISTA MOSAICO
          ==================================================== */

          <div
            className={
              dashboard.gridContainer
            }
          >

            {allItems.map(
              item => {

                const itemKey =
                  `${item.isFolder
                    ? "folder"
                    : "file"}-${item.id}`;


                return (

                  <div
                    key={itemKey}
                    className={
                      dashboard.gridItem
                    }
                  >

                    <span
                      className={
                        dashboard.itemIcon
                      }
                    >

                      {item.isFolder ? (

                        <img
                          src={folderIcon}
                          alt="folder"
                          className={
                            dashboard.iconos
                          }
                        />

                      ) : (

                        <img
                          src={
                            getFileIcon(
                              item.type
                            )
                          }
                          alt="file"
                          className={
                            dashboard.iconos
                          }
                        />

                      )}

                    </span>


                    {item.isFolder ? (

                      <button
                        className={
                          dashboard.folderLink
                        }
                        onClick={() =>
                          handleFolderClick(
                            item.id
                          )
                        }
                      >
                        {item.name}
                      </button>

                    ) : (

                      <span
                        className={
                          dashboard.gridItemLabel
                        }
                      >
                        {item.name}
                      </span>

                    )}


                    <button
                      className={
                        dashboard.menuButton
                      }
                      onClick={() =>
                        toggleItemMenu(
                          itemKey
                        )
                      }
                    >
                      ⋮
                    </button>


                    {openMenuKey ===
                      itemKey && (

                      <div
                        className={
                          dashboard.itemMenu
                        }
                      >

                        {item.isFolder && (

                          <div
                            onClick={() =>
                              handleFolderClick(
                                item.id
                              )
                            }
                          >
                            Abrir
                          </div>

                        )}


                        <div
                          onClick={() =>
                            handleDownload(
                              item.id,
                              item.name
                            )
                          }
                        >
                          Descargar
                        </div>


                        <div
                          onClick={() =>
                            handleDelete(
                              item.id,
                              item.isFolder
                            )
                          }
                        >
                          Borrar
                        </div>


                        <div
                          onClick={() =>
                            handleEdit(
                              item.id,
                              item.isFolder,
                              item.name
                            )
                          }
                        >
                          Editar
                        </div>


                        <div
                          onClick={() =>
                            handleShare(
                              item.id,
                              item.isFolder
                            )
                          }
                        >
                          Compartir
                        </div>

                      </div>

                    )}

                  </div>

                );

              }
            )}

          </div>

        )}


        {/* =====================================================
            PAPELERA
        ====================================================== */}

        <button
          onClick={
            goToTrash
          }
          className={
            dashboard.trashButton
          }
          title="Papelera"
        >

          <img
            src={borrarActual}
            alt="Papelera"
            className={
              dashboard.trashIcon
            }
          />

        </button>

      </main>

    </div>

  );

};


export default Dashboard;